export default __webpack_public_path__ + "static/media/Surprised.54d51171.svg";